export default () => jQuery(($) => {

	const form = $('.campus-directory__search-panel form');

	const directory = $('.campus-directory');

	form.submit(function (e) {
		directory.addClass('campus-directory--pending-results');
		$('.campus-directory__waiting-indicator').show();
	});

	$('.campus-directory__clear-form').click(function (event) {
		event.preventDefault();
		form.find('input[type="text"]').each(function () {
			$(this).val(''); // clears text inputs
		});

		form.find('select').each(function () {
			$(this)[0].selectedIndex = 0;
		}); // defaults selects to first item

		directory.addClass('campus-directory--pending-results');
		$('.campus-directory__waiting-indicator').hide();
		$('#scopeAffiliation').change();
		$('#firstName').focus();

		console.log('Directory Search form cleared');
	});

	$('.campus-directory__start-link').click(function (event) {
		event.preventDefault();
		$('#firstName').focus();
	});

	$('.campus-directory form').submit( function ( event ) {
		event.preventDefault();

		let getVars = [];
		$.each( $(this).find('input'), function (index, item) {
			if ($(item).attr('type') != 'submit' && $(item).val()) {
				getVars.push( $(item).attr('name') + '=' + $(item).val() );
			}
		} );
		$.each( $(this).find('select'), function (index, item) {
			if ($(item).val()) {
				if ( $(item).attr('name') == 'scopeAffiliation' && $(item).val() == 'all' ) {
					// skip it
				} else {
					getVars.push( $(item).attr('name') + '=' + encodeURIComponent( $(item).val() ) );
				}
			}
		} );
		window.location.href = '?' + getVars.join('&');
	});
});
